var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useMemo, useState } from 'react';
import { useDataContext } from '@/shared/providers/DataProvider';
import userStorage from '@/shared/services/userStorage';
import { KPIOptions } from '../tasks/taskboard/constants';
export const DashboardContext = React.createContext(null);
export const useDashboardContext = () => {
    const ctx = useContext(DashboardContext);
    if (!ctx) {
        throw new Error('Wrap app with DashboardProvider');
    }
    return ctx;
};
const companyIdStorageKey = 'HomeDashboardCompanyId';
const taskKpiStorageKey = 'HomeDashboardTaskKPI';
const DashboardProvider = ({ children }) => {
    var _a, _b;
    const { defaultCompany } = useDataContext();
    const [companyId, updateCompanyId] = useState((_a = userStorage.getItem(companyIdStorageKey)) !== null && _a !== void 0 ? _a : defaultCompany === null || defaultCompany === void 0 ? void 0 : defaultCompany.id);
    const [taskKpi, updateTaskKpi] = useState((_b = userStorage.getItem(taskKpiStorageKey)) !== null && _b !== void 0 ? _b : KPIOptions.total);
    const [editMode, setEditMode] = useState(false);
    const setCompanyId = useCallback((value) => {
        updateCompanyId(value);
        userStorage.setItem(companyIdStorageKey, value);
    }, [updateCompanyId]);
    const setTaskKpi = useCallback((value) => {
        updateTaskKpi(value);
        userStorage.setItem(taskKpiStorageKey, value);
    }, [updateTaskKpi]);
    const value = useMemo(() => ({
        companyId,
        setCompanyId,
        taskKpi,
        setTaskKpi,
        editMode,
        setEditMode,
    }), [companyId, setCompanyId, taskKpi, setTaskKpi, editMode]);
    return _jsx(DashboardContext.Provider, Object.assign({ value: value }, { children: children }));
};
export const withDashboardProvider = Component => (_a) => {
    var passThroughProps = __rest(_a, []);
    return (_jsx(DashboardProvider, { children: _jsx(Component, Object.assign({}, passThroughProps)) }));
};
export const injectDashboardContext = WrappedComponent => props => (_jsx(DashboardContext.Consumer, { children: service => _jsx(WrappedComponent, Object.assign({ dashboardContext: service }, props)) }));
export default DashboardProvider;
